export default "https://cdn-static.gokick.com/assets/6909edbc169b94fbe838446b12805066cb856688/images/tangerine-flavor.074c3354820283b11da157ce9290935a.png";